let load = require('./helpers/browser/esm-js-loader-shards')(5);
module.exports = Promise.all([load("hyqsV"), load("5LCFM")]).then(() => parcelRequire('huNwZ'));